"use client";
const _ = "__ask_ai__";
export {
  _ as ASK_AI_TRIGGER_VALUE
};
